import React from "react";
import { forceUseHookDependencies } from "@hex-insights/core";

// TODO move to core
// TODO unite with responsive grid logic
export function useElementSize(ref: React.MutableRefObject<HTMLElement | null>, key?: any) {
	const [width, setWidth] = React.useState(0);

	const updateGridWidth = React.useCallback(() => {
		forceUseHookDependencies(key);
		if (!ref.current) {
			return;
		}
		setWidth(ref.current.clientWidth);
	}, [ref, key]);

	React.useLayoutEffect(() => {
		updateGridWidth();
	}, [updateGridWidth]);

	React.useEffect(() => {
		forceUseHookDependencies(key);
		if (!ref.current) {
			return;
		}
		const observer = new ResizeObserver(() => {
			updateGridWidth();
		});

		observer.observe(ref.current);

		return () => {
			observer.disconnect();
		};
	}, [ref, updateGridWidth, key]);

	return { width };
}
